export default __webpack_public_path__ + "static/media/redX.6ba2e76e.svg";